import { render, staticRenderFns } from "./shop-channel-form-lazada.vue?vue&type=template&id=1a452282"
import script from "./shop-channel-form-lazada.vue?vue&type=script&lang=js"
export * from "./shop-channel-form-lazada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports